import _slicedToArray from '../../../../node_modules/@babel/runtime/helpers/slicedToArray.es.js';
import { gridDimensions } from '@mgmresorts/wcl-styled';
import React, { useState, useRef, useEffect } from 'react';
import useDebouncedCallback from '../../../../node_modules/use-debounce/esm/useDebouncedCallback.es.js';
import { ViewportContext, calculateViewportContextValue } from './ViewportContext.es.js';

var defaultContextValue = {
  lg: false,
  maxLg: false,
  maxMd: false,
  maxSm: false,
  md: false,
  minLg: true,
  minMd: true,
  minXl: true,
  sm: false,
  type: 'xl',
  xl: true
};
var ViewportContextProvider = function ViewportContextProvider(_ref) {
  var children = _ref.children,
      _ref$forceSSR = _ref.forceSSR,
      forceSSR = _ref$forceSSR === void 0 ? false : _ref$forceSSR;
  var initialContextValue = forceSSR ? defaultContextValue : undefined;

  var _useState = useState(initialContextValue),
      _useState2 = _slicedToArray(_useState, 2),
      contextValue = _useState2[0],
      setContextValue = _useState2[1];

  var mediaQueryLists = useRef([]);

  var updateContextValue = function updateContextValue() {
    var nextContextValue = calculateViewportContextValue({
      windowWidth: window.innerWidth
    });
    setContextValue(nextContextValue);
  };

  var _useDebouncedCallback = useDebouncedCallback(updateContextValue, 30),
      _useDebouncedCallback2 = _slicedToArray(_useDebouncedCallback, 1),
      handleMediaQueryListChange = _useDebouncedCallback2[0];

  useEffect(function () {
    var widths = Object.values(gridDimensions).map(function (grid) {
      return grid.minScreenWidth;
    }).filter(function (w) {
      return w !== 0;
    });
    var nextMediaQueryLists = widths.map(function (width) {
      var mql = window.matchMedia("(min-width: ".concat(width, "px)"));
      mql.addListener(handleMediaQueryListChange);
      return mql;
    });
    mediaQueryLists.current = nextMediaQueryLists;
    return function () {
      mediaQueryLists.current.forEach(function (mql) {
        mql.removeListener(handleMediaQueryListChange);
      });
    };
  }, // In reality handleMediaQueryListChange never changes
  // (and this effect will fire only once, after component mount),
  // but it's a nice practice to put it into useEffect `deps` array anyways.
  [handleMediaQueryListChange]);
  useEffect(function () {
    updateContextValue();
  }, []);
  /*
    if we don't have a valid window size yet, don't render anything.
    this removes the "flicker" effect that would occur by trying to guess
    the screen size during SSR.  don't guess, just don't show anything.
    therefore the first paint is going to be SUPER fast, cause it won't
    paint anything, it's just grabbing the screen size, then it starts the
    render cycle over (with rendered.current === true) and the screen size
    known...
  */

  return contextValue ? /*#__PURE__*/React.createElement(ViewportContext.Provider, {
    value: contextValue
  }, children) : null;
};

export { ViewportContextProvider };
